import { render, staticRenderFns } from "./Cancelation.vue?vue&type=template&id=52b99bc4&"
import script from "./Cancelation.vue?vue&type=script&lang=js&"
export * from "./Cancelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports